// extracted by mini-css-extract-plugin
export var subtitle = "_aj-2";
export var title = "_aj-0";
export var titleNoWrap = "_aj-1";